import { LoadingStates } from './types'

export function possessiveNoun(name: string) {
  return name.endsWith('s') ? `${name}'` : `${name}'s`
}

export function capitalize(str: string) {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
}

export function truncate(text: string, max: number) {
  let string = text.substr(0, max - 1)
  if (text.length > max) string += '...'
  return string
}

export const stateChangedTo = (
  toState: string,
  prevState: string,
  state: string,
) => {
  if (!toState || !prevState || !state) return

  return prevState !== state && state === toState
}

function propsStateChange<
  T extends Record<K, LoadingStates>,
  K extends keyof T,
>(props: T, prevProps: T, stateKey: K, state: LoadingStates) {
  const currState = props[stateKey]
  const prevState = prevProps[stateKey]

  return currState !== prevState && currState === state
}

export function justSucceeded<
  T extends Record<K, LoadingStates>,
  K extends keyof T,
>(props: T, prevProps: T, stateKey: K) {
  return propsStateChange(props, prevProps, stateKey, 'success')
}

/**
 * Oxford comma helper.
 *
 * oxfordComma(['a', 'b', 'c']) => "a, b, and c"
 */
export function oxfordComma(
  items: string[],
  options?: { andSubstitute?: string; limit?: number },
): string {
  const { andSubstitute, limit } = options || {}
  const joiner = andSubstitute ? ` ${andSubstitute} ` : ' and '
  const leftOver = items.slice(limit || items.length)

  if (items.length == 1) return items[0]
  else if (items.length <= 2) return items.join(joiner)
  else if (leftOver.length > 0 && limit && limit === 1)
    return `${items[0]}${joiner}${leftOver.length} others`
  else if (leftOver.length > 0 && limit && limit > 1)
    return `${items.slice(0, limit).join(', ')},${joiner}${
      leftOver.length
    } other${leftOver.length === 1 ? '' : 's'}`
  else return `${items.slice(0, -1).join(', ')},${joiner}${items.slice(-1)[0]}`
}

export function formatTagName(name: string): string {
  return name
    .split(' ')
    .map(part => capitalize(part))
    .join(' ')
}

export const aOrAn = (wordAfter: string, capitalize = false) => {
  if (
    ['a', 'e', 'i', 'o', 'u'].some(
      consanant => consanant == wordAfter.charAt(0).toLowerCase(),
    )
  ) {
    return capitalize ? 'An' : 'an'
  } else {
    return capitalize ? 'A' : 'a'
  }
}

export function wordCount(text: string): number {
  return text.match(/\S+/g)?.length || 0
}

export function isValidURL(url: string): boolean {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // fragment locator
  return !!pattern.test(url)
}
